import { gql, useQuery } from '@apollo/client';

export const GET_CURRENT_MEMBER = gql`
  query {
    getCurrentMember {
      _id
      type
      ganttId
      gantt {
        employeeGanttOrderIds
        colorSchema {
          holidayColor
          todayColor
          weekendColor
        }
      }
      ganttsAccess {
        ganttId
        accessRight
      }
      ownerCompany {
        name
        street
        city
        country
        zipCode
      }
      subscriptions {
        stripeSubscriptionId
        softwarePlan {
          name
        }
        softwareModule {
          name
        }
      }
    }
  }
`;

export const SUBSCRIPTION_CURRENT_MEMBER = gql`
  subscription {
    currentMemberChanged {
      _id
      type
      ganttId
      gantt {
        employeeGanttOrderIds
        colorSchema {
          holidayColor
          todayColor
          weekendColor
        }
      }
      ganttsAccess {
        ganttId
        accessRight
      }
      ownerCompany {
        name
        street
        city
        country
        zipCode
      }
      subscriptions {
        stripeSubscriptionId
        softwarePlan {
          _id
          name
        }
        softwareModule {
          _id
          name
        }
      }
    }
  }
`;

export const useGetCurrentMemberAccount = () => {
  const { data, loading, subscribeToMore, refetch } = useQuery(GET_CURRENT_MEMBER);

  const { getCurrentMember = {} } = data || {};

  subscribeToMore({
    document: SUBSCRIPTION_CURRENT_MEMBER,
    updateQuery: (prev, { subscriptionData }) => {
      if (!subscriptionData.data) return prev;

      return { getCurrentMember: subscriptionData.data.currentMemberChanged };
    },
  });

  return {
    loading,
    member: getCurrentMember,
    refetch,
  };
};
